import cn from 'classnames';

import { IConDefaultType } from '../types';

enum MultiImageIconVariant {
  DEFAULT = 'default',
}
export interface IMultiImageIconProps extends IConDefaultType {
  variant?: MultiImageIconVariant;
}

export default function MultiImageIcon({
  color,
  className,
  size = 24,
  rotate,
  flip,
  variant = MultiImageIconVariant.DEFAULT,
}: IMultiImageIconProps) {
  const style = {
    width: size,
    minWidth: size,
    height: size,
    transform: `rotate(${rotate}deg)`,
  };

  return (
    <i className={cn('dds-icon', className, { flip })} style={style}>
      {variant === MultiImageIconVariant.DEFAULT && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 20" fill="none">
          <path
            d="M14.5562 1.72849L8.75921 1.69955C7.60611 1.6938 6.49795 2.14634 5.67851 2.95764C4.85907 3.76893 4.39548 4.87252 4.38973 6.02562L4.36079 11.8226C4.35503 12.9757 4.80757 14.0839 5.61887 14.9033C6.43016 15.7228 7.53375 16.1864 8.68685 16.1921L14.4839 16.2211C15.637 16.2268 16.7451 15.7743 17.5646 14.963C18.384 14.1517 18.8476 13.0481 18.8534 11.895L18.8823 6.09797C18.8881 4.94487 18.4355 3.83672 17.6242 3.01728C16.8129 2.19784 15.7093 1.73425 14.5562 1.72849ZM5.83899 6.03285C5.84282 5.26412 6.15188 4.52839 6.69817 3.98753C7.24447 3.44667 7.98324 3.14497 8.75197 3.14881L14.549 3.17775C15.3177 3.18159 16.0535 3.49065 16.5943 4.03694C17.1352 4.58323 17.4369 5.322 17.433 6.09074L17.4041 11.8878C17.4022 12.0752 17.3819 12.262 17.3433 12.4454L14.8007 10.8168C14.3943 10.5467 13.9176 10.4015 13.4296 10.399C12.9416 10.3966 12.4635 10.5371 12.0544 10.8031L11.7926 10.9757C11.6511 11.0729 11.4815 11.1208 11.31 11.1121C11.1385 11.1034 10.9746 11.0385 10.8436 10.9275L9.10448 9.46949C8.69379 9.12597 8.17914 8.93117 7.64392 8.91666C7.1087 8.90215 6.58426 9.06878 6.15556 9.38955L5.8209 9.656L5.83899 6.03285Z"
            fill={color}
          />
          <path
            d="M13.4331 8.96936C12.9527 8.96696 12.4928 8.7738 12.1548 8.43236C11.8167 8.09093 11.6282 7.6292 11.6306 7.14874C11.633 6.66828 11.8261 6.20845 12.1676 5.87041C12.509 5.53237 12.9707 5.34381 13.4512 5.34621C13.9317 5.34861 14.3915 5.54177 14.7295 5.8832C15.0676 6.22463 15.2561 6.68637 15.2537 7.16683C15.2513 7.64729 15.0582 8.10712 14.7167 8.44516C14.3753 8.78319 13.9136 8.97175 13.4331 8.96936ZM13.444 6.79547C13.3479 6.79499 13.2555 6.8327 13.1872 6.90031C13.119 6.96792 13.0803 7.05988 13.0798 7.15597C13.0794 7.25207 13.1171 7.34441 13.1847 7.4127C13.2523 7.48099 13.3443 7.51962 13.4404 7.5201C13.5364 7.52058 13.6288 7.48287 13.6971 7.41526C13.7654 7.34765 13.804 7.25568 13.8045 7.15959C13.805 7.0635 13.7672 6.97115 13.6996 6.90287C13.632 6.83458 13.5401 6.79595 13.444 6.79547Z"
            fill={color}
          />
          <path
            d="M3.67043 4.95519C2.77697 5.74686 2.21142 6.90098 2.20499 8.18865L2.17605 13.9857C2.16406 16.3869 4.1009 18.3432 6.50211 18.3552L12.2991 18.3841C13.5868 18.3905 14.7465 17.8365 15.5471 16.951L6.50935 16.9059C4.90854 16.8979 3.61731 15.5937 3.6253 13.9929L3.67043 4.95519Z"
            fill={color}
          />
        </svg>
      )}
    </i>
  );
}
